module.exports = __webpack_public_path__ + "img/monitor.44d534fc.png";